import { createSlice } from '@reduxjs/toolkit';

import { EsignatureIntegrationWithMetadata } from '~/features/admin/ESignature/types';
import { initialFilters } from '~/features/integrations/constants';
import { Nullable } from '~/types/Nullable';

interface State {
  selectedFilters: typeof initialFilters;
  action: Nullable<string>;
  esignatureIntegration: EsignatureIntegrationWithMetadata | undefined;
}

const initialState: State = {
  selectedFilters: initialFilters,
  action: null,
  esignatureIntegration: undefined,
};

export default createSlice({
  name: 'newIntegrations',
  initialState,
  selectors: {
    selectEsignatureIntegration: (state) => state.esignatureIntegration,
    selectedFilters: (state) => state.selectedFilters,
    selectAction: (state) => state.action,
  },
  reducers: {
    setEsignatureIntegration: (state, action) => {
      state.esignatureIntegration = action.payload;
    },
    setAction: (state, action) => {
      state.action = action.payload;
    },
    setFilters: (state, action) => {
      return {
        ...state,
        selectedFilters: action.payload,
      };
    },
    resetFilters: (state) => {
      state.selectedFilters = initialFilters;
    },
  },
});
